import { render, staticRenderFns } from "./template.vue?vue&type=template&id=42323a00&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=42323a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42323a00",
  null
  
)

export default component.exports